export const config = {
    type: 'HOTSPOT_IMAGE',
    title: '热区图片',
    defaultProps: {
        image: '',
        hotspots: [],
        imageStyle: {
            width: '100%',
            height: '320',
            borderRadius: '0',
            objectFit: 'contain'
        },
        style: {
            backgroundColor: "transparent",
            padding: '0px',
            borderRadius: "0px",
            marginBottom: "0px",
            marginLeft: "0px",
            marginRight: "0px",
            marginTop: "0px",
            minHeight: "100px",
        }
    },
    preview: {
        style: {
            padding: '8px'
        },
        items: [
            {
                style: {
                    margin: '0 auto',
                    width: '60%',
                    height: '80px',
                    background: 'var(--semi-color-fill-2)',
                    borderRadius: '4px'
                }
            }
        ]
    }
};